import TextInputField from "@/components/forms/TextInputField.tsx";
import NumberInputField from "@/components/forms/NumberInputField.tsx";
import FormSection from "@/components/forms/FormSection.tsx";

export default function CharacterDefenseForm() {
    return <FormSection title="Kampfwerte" contentClassName="grid gap-3 md:grid-cols-2 xl:grid-cols-4">
        <NumberInputField name="hitPoints.value" title="Trefferpunkte"/>
        <TextInputField name="hitPoints.formula" title="TP-Würfel"/>
        <NumberInputField name="armorClass.value" title="Rüstungsklasse"/>
        <TextInputField name="armorClass.info" title="Rüstungsinfo"/>
    </FormSection>;
}
